import { TableCell, TableRow } from "@mui/material"

function TableRowStatic({ children, actions, loaded }) {
  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      data-cy="table-row-static"
    >
      {children}
      {loaded &&
        <TableCell align="center" p={0}>
          {actions}
        </TableCell>
      }
    </TableRow>
  );
}

export default TableRowStatic